import * as React from 'react';
import { /*useState, */ useEffect, useRef } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { blue, red } from '@mui/material/colors';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import PinDropIcon from '@mui/icons-material/PinDrop';

import moment from 'moment';

import uPlot from 'uplot';
import UplotReact from 'uplot-react';
import 'uplot/dist/uPlot.min.css';

import './overlay_tooltip.css';
//import placement from './index.placement.es.js';
//import placement from 'placement.js';

// import Control from 'react-leaflet-custom-control'
// import {Marker, Popup, useMap} from 'react-leaflet';
// import {MapContainer} from 'react-leaflet/MapContainer'
// import {TileLayer} from 'react-leaflet/TileLayer'
// import 'leaflet/dist/leaflet.css';
// import L from 'leaflet';

import {
  useSensorData,
  useSensorDataColumnar
} from '../../utils/device';

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  Title, Tooltip, Filler, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement,
  Title, Tooltip, Filler, Legend);

function MapPointList({list, onPointSelect}) {
  const handleListPointClick = (el) => {
    console.log("handleListPointClick : ", el);
    if (onPointSelect) onPointSelect(el);
  }

  var pointList = list.map((el) => {
    return (
      <ListItem key={el.uuid} onClick={()=>{handleListPointClick(el)}}>
        <ListItemAvatar>
          <Avatar><PinDropIcon/></Avatar>
        </ListItemAvatar>
        <ListItemText primary={`speed ${el.speed}`}
        secondary={moment(el.utc_time).format('Do MMMM YYYY, HH:mm:ss ')} />
      </ListItem>
    );
    // return (
    //   <Marker key={el.utc_time} position={[el.latitude, el.longitude]}>
    //     <Popup>speed {el.speed} at {el.utc_time}</Popup>
    //   </Marker>
    // );
  });

//   sx={{
//   width: '100%',
//   maxWidth: 360,
//   bgcolor: 'background.paper',
//   position: 'relative',
//   overflow: 'auto',
//   maxHeight: 300,
//   '& ul': { padding: 0 },
// }}

  return (
    <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper',
        position: 'relative', overflow: 'auto', maxHeight: 360}}>
      {pointList}
    </List>
  );
}

function DevLineChart({data, dataKey, min, max, unit, caption}) {

  const opts = {
    responsive: true,
    scales: {
      y : {
        suggestedMin:min,
        suggestedMax:max,
      },
      // x: {
      //           type: 'time',
      //           time: {
      //               unit: 'month'
      //           }
      //       }
    },
    parsing: {
      xAxisKey: 'date_str',
      yAxisKey: dataKey
    },
    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: true,
        text: caption ? caption : "Sensor",
      },
      // zoom: {
      //   zoom: {
      //     wheel: {
      //       enabled: true,
      //     },
      //     // pinch: {
      //     //   enabled: true
      //     // },
      //     mode: 'x',
      //     speed: 100
      //     //threshold : 100
      //   },
      //   pan: {
      //     enabled: true,
      //     mode: "x",
      //     speed: 0.5
      //   }
      // }
    }
  };

  const lineData = {
    datasets: [
      {
        fill: false,
        label: caption ? caption : "Sensor",
        data : data,
        //data: [{x: '2016-12-25', y: 20}, {x: '2016-12-26', y: 10}],
        // data: keys.map((key) => {
        //   console.log("key : ", key );
        //   //console.log("data[key][dataKey] : ", data[key][dataKey]);
        //   return data[key][dataKey]
        // }),
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)'
      }
    ]
  };

  return (
    <Line options={opts} data={lineData} />
  )
}

function tooltipPlugin(opts) {
  let cursortt;
  let seriestt;

  function init(u, opts, data) {
    let over = u.over;

    let tt = cursortt = document.createElement("div");
    tt.className = "tooltip";
    tt.textContent = "(x,y)";
    tt.style.pointerEvents = "none";
    tt.style.position = "absolute";
    tt.style.background = "rgba(0,0,255,0.1)";
    over.appendChild(tt);

    seriestt = opts.series.map((s, i) => {
      if (i === 0) return;

      let tt = document.createElement("div");
      tt.className = "tooltip";
      tt.textContent = "Tooltip!";
      tt.style.pointerEvents = "none";
      tt.style.position = "absolute";
      tt.style.background = "rgba(0,0,0,0.1)";
      tt.style.color = s.color;
      //over.appendChild(tt);
      return tt;
    });

    function hideTips() {
      cursortt.style.display = "none";
      seriestt.forEach((tt, i) => {
        if (i === 0) return;

        tt.style.display = "none";
      });
    }

    function showTips() {
      cursortt.style.display = null;
      seriestt.forEach((tt, i) => {
        if (i === 0) return;

        let s = u.series[i];
        tt.style.display = s.show ? null : "none";
      });
    }

    over.addEventListener("mouseleave", () => {
      if (!u.cursor._lock) {
      //	u.setCursor({left: -10, top: -10});
        hideTips();
      }
    });

    over.addEventListener("mouseenter", () => {
      showTips();
    });

    if (u.cursor.left < 0)
      hideTips();
    else
      showTips();
  }

  function setCursor(u) {
    const {left, top, idx} = u.cursor;

    opts?.cursorMemo?.set(left, top);

    // this is here to handle if initial cursor position is set
    // not great (can be optimized by doing more enter/leave state transition tracking)
  //	if (left > 0)
  //		u.cursortt.style.display = null;

    cursortt.style.left = left + "px";
    cursortt.style.top = top-20 + "px";
    //cursortt.textContent = "(" + u.posToVal(left, "x").toFixed(2) + ", " + u.posToVal(top, "y").toFixed(2) + ")";
    //cursortt.textContent = "(dyn " + u.posToVal(left, "x").toFixed(2) + ", " + u.posToVal(top, "y").toFixed(2) + ")";



    // can optimize further by not applying styles if idx did not change
    seriestt.forEach((tt, i) => {
      if (i === 0) return;

      let s = u.series[i];

      if (s.show) {
        // this is here to handle if initial cursor position is set
        // not great (can be optimized by doing more enter/leave state transition tracking)
      //	if (left > 0)
      //		tt.style.display = null;

        let xVal = u.data[0][idx];
        let yVal = u.data[i][idx];

        //tt.textContent = "(" + xVal + ", " + yVal + ")";
        //tt.textContent = "(" + new Date(xVal * 1e3).toLocaleString('lv-LV') + ", " + yVal + ")";
        tt.textContent = `${yVal} Wh`;

        cursortt.textContent = `${yVal} Wh`;

        tt.style.left = Math.round(u.valToPos(xVal, 'x')) + "px";
        tt.style.top = Math.round(u.valToPos(yVal, s.scale)-20) + "px";
      }
    });
  }

  return {
    hooks: {
      init,
      setCursor,
      setScale: [
        (u, key) => {
          //console.log('setScale', key);
        }
      ],
      setSeries: [
        (u, idx) => {
          //console.log('setSeries', idx);
        }
      ],
    },
  };
};

function DeviceDDS238_2_ZN({uuid, attributes, dateRange, dateFrom}) {

  // const ref = useRef(null);
  // const upRef = useRef(null);

  var {data, isFetching} = useSensorDataColumnar(
    uuid, dateRange, dateFrom, 'ACTIVE_POWER');

  // useEffect(() => {
  //   console.log("upRef : ", upRef.current);
  //   // console.log("useEffect : ", ref.current);
  //   // const observer = new ResizeObserver((entries) => {
  //   //   //setwidth(entries[0].contentRect.width)
  //   //   console.log("entries[0].contentRect.width : ", entries[0].contentRect.width);
  //   // });
  //   // observer.observe(ref.current);
  //   // return () => ref.current && observer.unobserve(ref.current);
  // }, [])

  if (isFetching) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    )
  }

  // let data = [
  //   [1546300800, 1546387200],    // x-values (timestamps)
  //   [        35,         71],    // y-values (series 1)
  // ];


  let opts = {
  //title: "Active power",
  title : "Consumption (Wh)",
  id: "chart1",
  class: "my-chart",
  width: 1600,
  height: 600,
  plugins: [
    tooltipPlugin()
  ],
  series: [
    {
      value: (self, rawValue) => {
        //console.log("rawValue : ", rawValue);
        if (rawValue)
          //return rawValue+"time"
          return new Date(rawValue * 1e3).toLocaleString('lv-LV');
        //moment(rawValue).format('Do MMM YYYY, HH:mm:ss ');
      },
    },
    {
      // initial toggled state (optional)
      show: true,
      spanGaps: true,

      // in-legend display
      label: "Active power",

      value: (self, rawValue) => {
        //console.log("rawValue : ", rawValue);
        if (rawValue)
          return rawValue.toFixed(1)+' Wh';
      },

      // series style
      stroke: "red",
      width: 1,
      fill: "rgba(255, 0, 0, 0.3)",
      dash: [10, 5],
    }
  ],
  axes: [
    {
      space: 40,
      incrs: [
         // minute divisors (# of secs)
         1,
         5,
         10,
         15,
         30,
         // hour divisors
         60,
         60 * 5,
         60 * 10,
         60 * 15,
         60 * 30,
         // day divisors
         3600,
      // ...
      ],
      // [0]:   minimum num secs in found axis split (tick incr)
      // [1]:   default tick format
      // [2-7]: rollover tick formats
      // [8]:   mode: 0: replace [1] -> [2-7], 1: concat [1] + [2-7]
      values: [
      // tick incr          default           year                             month    day                        hour     min                sec       mode
        [3600 * 24 * 365,   "{YYYY}",         null,                            null,    null,                      null,    null,              null,        1],
        [3600 * 24 * 28,    "{MMM}",          "\n{YYYY}",                      null,    null,                      null,    null,              null,        1],
        [3600 * 24,         "{D}/{M}",        "\n{YYYY}",                      null,    null,                      null,    null,              null,        1],
        [3600,              "{HH}:{mm}",      "\n{D}/{M}/{YY}",                null,    "\n{D}/{M}",               null,    null,              null,        1],
        [60,                "{HH}:{mm}",      "\n{D}/{M}/{YY}",                null,    "\n{D}/{M}",               null,    null,              null,        1],
        [1,                 ":{ss}",          "\n{D}/{M}/{YY} {HH}:{mm}",      null,    "\n{D}/{M} {HH}:{mm}",     null,    "\n{h}:{mm}",      null,        1],
        [0.001,             ":{ss}.{fff}",    "\n{D}/{M}/{YY} {HH}:{mm}",      null,    "\n{D}/{M} {HH}:{mm}",     null,    "\n{h}:{mm}",      null,        1],
      ],
  //  splits:
    }, {
      label: "Wh",
      labelSize: 30,
    }
  ]
};

  return (
    <Box>
      <UplotReact options={opts} data={data}/>
    </Box>
  )

}

// function DeviceDDS238_2_ZN({uuid, attributes, dateRange, dateFrom}) {
//   console.log("dateRange, date : ", dateRange, dateFrom);
//   var {data, isFetching} = useSensorData(uuid, dateRange, dateFrom);
//   console.log("DeviceDDS238_2_ZN Chart data : ", data);
//
//   if (isFetching) {
//     return (
//       <Box sx={{ display: 'flex' }}>
//         <CircularProgress />
//       </Box>
//     )
//   }
//
// //  var activePower = [];
//   // var sensorTagData = [];
//   // var sensorTagDataObj = {};
//
//   for (let i = 0; i < data.length; i++) {
//      var el = data[i];
//   //
//   //   if (el.key === "ACTIVE_POWER") {
//        //var sensor = el.value;
//        var d = new Date(el.value_timestamp);
//        //sensor["uuid"] = el.uuid;
//        data[i]["date"] = d;
//        data[i]["date_str"] = data[i]["date"].toLocaleString('lv-LV');
//
//        //sensor["ACTIVE_POWER"] = parseFloat(sensor["build_in_light_lux"]);
//   //     sensor["build_in_light_lux"] = parseFloat(sensor["build_in_light_lux"]);
//   //     sensor["build_in_temperature"] = parseFloat(sensor["build_in_temperature"]);
//   //     sensorTagData.push(sensor);
//   //
//   //   }
//   }
//   // console.log("sensorTagData : ", sensorTagData);
//   //console.log("pointsTagData : ", pointsTagData);
//   // console.log("sensorTagDataObj : ", sensorTagDataObj);
//
//   // var lPoint = pointsTagData[pointsTagData.length-1];
//   // var lastPoint = lPoint ? {lat: lPoint.latitude, lng: lPoint.longitude} : {lat: 56.9677, lng: 24.1056};
//
//   return (
//     <Box>
//       {/*
//       <DevLineChart data={data} caption={"Build in temperature sensor"}
//       dataKey="key" min={-30} max={70} unit="°"/>
//
//        <DevLineChart data={sensorTagData} caption={"Build in humidity sensor"}
//         dataKey="build_in_humidity" min={0} max={100} unit="%"/>
//
//       <DevLineChart data={sensorTagData} caption={"Build in light sensor"}
//         dataKey="build_in_light_lux" min={0} max={700} unit="lx"/> */}
//     </Box>
//   )
// }

export {
  DeviceDDS238_2_ZN
}
